module.exports = __webpack_public_path__ + "assets/a2321135b9c45a57e081f3a47ac31a0d.svg";